var option_default = {
  "option": "qRH-b",
  "user_choice": "cqH--",
  "check": "_2-J9a",
  "image": "_3BxId",
  "input": "KSrgN",
  "title": "b1Zyt",
  "centered": "_5NJ4q",
  "with_result": "O1iXR",
  "list": "VJh4S",
  "with_image": "JiZ5R",
  "progress": "-wNa7",
  "progress_value": "qAQz3",
  "label": "M8aYQ",
  "cta": "f05P-",
  "adornment_icon": "HsJ4o",
  "remove": "HnHYw",
  "removeButton": "I09Mc",
  "removeButtonIcon": "Jzuwr",
  "overlay": "Fo4b2",
  "shown": "TyolT",
  "dark": "Ew5r0",
  "spinner": "g0XZs",
  "spin": "RwRf8"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
